import { render, staticRenderFns } from "./MoleculeEditionAcademyUsersProfileSales.vue?vue&type=template&id=23ac55fd&"
import script from "./MoleculeEditionAcademyUsersProfileSales.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsersProfileSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports